/* ==========================================================================
   Alpenberger - Varianten- und Farbfeld-Darstellung
   Theme: Pillar (Hyper 1.3.3).  Datei: assets/varyant-gorunum.js
   Arbeitet auf dem bestehenden Markup. Keine Liquid-Aenderung noetig.

   Aufgaben:
     1) Farbfelder mit gueltigen Werten belegen (Theme schreibt "schwarz"
        statt "#1A1A1A" -> Feld bleibt sonst transparent)
     2) Anzahl der Farben auf der Karte ausweisen
     3) Varianten-Buttons einheitlich als Chips darstellen (Bernstein-Stil):
        kurze Beschriftung, Ueberlauf hinter "+N"

   WICHTIG: Beim Variantenwechsel rendert Shopify die Section neu. Das
   frisch geladene Markup kennt weder .ab-chips noch die gekuerzten
   Beschriftungen. Der MutationObserver am Dateiende baut die Chips
   deshalb nach jedem Nachladen erneut auf.
   ========================================================================== */
(function () {
  'use strict';

  var CDN = '//shop.alpenberger.de/cdn/shop/files/';

  /* Wie viele Chips sichtbar bleiben, bevor "+N" greift */
  var CHIPS_VISIBLE = 4;

  /* Produktdaten einmal laden und fuer spaetere Durchlaeufe vorhalten */
  var PRODUCT = null;

  /* --- Farbwert -> Feld -------------------------------------------------- */
  var FARBE = {
    'eiche natur':      { img: 'Eiche_Natur_jpg.jpg' },
    'eiche':            { img: 'Eiche_jpg.jpg' },
    'eiche hell':       { img: 'Eiche_Hell.jpg' },
    'bamboo':           { img: 'Bamboo_jpg.jpg' },
    'light coffee':     { img: 'Light_Coffe.jpg' },
    'cement':           { img: 'Cement_jpg.jpg' },
    'schwarz matt':     { img: 'Schwarz_Matt_jpg.jpg' },
    'schwarz-matt':     { img: 'Schwarz_Matt_jpg.jpg' },
    'anthrazit matt':   { img: 'Anthrazit_matt.jpg' },
    'anthrazit':        { img: 'Anthrazit_matt.jpg' },
    'weiss hochglanz':  { img: 'Weiss_jpg.jpg' },
    'weiss glänzend':   { hex: '#FBFBFA', gloss: true },
    'weiss':            { hex: '#F7F7F5' },
    'weiß':             { hex: '#F7F7F5' },
    'schwarz':          { hex: '#1A1A1A' },
    'matt grey':        { hex: '#8B8D8A' },
    'grau':             { hex: '#9C9C9C' },
    'weiß mit calacatta platte':        { hex: '#F7F7F5', hex2: '#E8E4DC' },
    'schwarz mit calacatta platte':     { hex: '#1A1A1A', hex2: '#E8E4DC' },
    'eiche natur mit montblanc platte': { img: 'Eiche_Natur_jpg.jpg', hex2: '#EDEBE6' },
    'eiche mit montblanc platte':       { img: 'Eiche_jpg.jpg', hex2: '#EDEBE6' }
  };

  function norm(s) {
    return (s || '').trim().toLowerCase().replace(/\s+/g, ' ');
  }

  function esc(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function applyFarbe(el, name) {
    var d = FARBE[norm(name)];
    if (!d) { el.setAttribute('data-ab-unresolved', '1'); return false; }
    var url = d.img ? 'url(' + CDN + d.img + '&width=120)' : null;
    if (d.hex2) {
      el.style.backgroundImage = url
        ? 'linear-gradient(135deg,transparent 49%,' + d.hex2 + ' 51%),' + url
        : 'linear-gradient(135deg,' + d.hex + ' 49%,' + d.hex2 + ' 51%)';
      el.style.backgroundSize = 'cover';
    } else if (d.gloss) {
      el.style.backgroundImage =
        'linear-gradient(135deg,#fff 0%,#eceae5 45%,#fff 60%,#e4e2dc 100%)';
    } else if (url) {
      el.style.backgroundImage = url;
      el.style.backgroundSize = 'cover';
      el.style.backgroundPosition = 'center';
    } else {
      el.style.setProperty('--swatch-background', d.hex);
      el.style.backgroundColor = d.hex;
    }
    el.removeAttribute('data-ab-unresolved');
    return true;
  }

  /* Name des Farbwerts aus dem vorhandenen Markup lesen.
     Auf der Produktseite liegt der Tooltip NEBEN dem Farbfeld (im Label),
     auf der Karte darin. Deshalb vom Feld aus nach oben suchen und
     zusaetzlich den Wert des zugehoerigen Radio-Inputs heranziehen. */
  function farbeName(a) {
    var scope = a.closest('label') || a.closest('li') || a;
    var tip = a.querySelector('.tooltip') || scope.querySelector('.tooltip');
    if (tip && tip.textContent.trim()) return tip.textContent.trim();

    var lab = a.closest('label');
    if (lab && lab.getAttribute('for')) {
      var inp = document.getElementById(lab.getAttribute('for'));
      if (inp && inp.value) return inp.value;
    }
    var t = a.getAttribute('title') || a.getAttribute('aria-label') ||
            scope.getAttribute('title') || scope.getAttribute('aria-label') || '';
    var i = t.lastIndexOf(' - ');
    return i > -1 ? t.slice(i + 3) : t;
  }

  /* Hat das Theme bereits ein Bild hinterlegt? Es kann als background-image
     ODER in der Variablen --swatch-background stehen. Beide Wege pruefen -
     sonst wird ein korrekt gesetztes Feld ueberschrieben. */
  function hasThemeImage(a) {
    if ((a.style.backgroundImage || '').indexOf('url(') > -1) return true;
    var v = a.style.getPropertyValue('--swatch-background') ||
            getComputedStyle(a).getPropertyValue('--swatch-background') || '';
    return v.indexOf('url(') > -1;
  }

  function fixSwatches(root) {
    (root || document).querySelectorAll('.swatch-color').forEach(function (a) {
      if (a.dataset.abDone) return;
      a.dataset.abDone = '1';
      if (hasThemeImage(a)) return;              // schon korrekt - nicht anfassen
      var name = farbeName(a);
      if (!name) return;                          // kein Name lesbar: unveraendert lassen
      applyFarbe(a, name);
    });
  }

  /* Anzahl der Farben auf der Karte ausweisen */
  function colorCount(root) {
    (root || document).querySelectorAll('.swatches--product-card').forEach(function (ul) {
      if (ul.dataset.abCount) return;
      ul.dataset.abCount = '1';
      var n = ul.querySelectorAll('.swatch-item:not(.swatch-more)').length;
      var more = ul.querySelector('.swatch-more');
      if (more) {
        var m = (more.textContent || '').match(/\d+/);
        if (m) n += parseInt(m[0], 10);
      }
      if (n < 2) return;
      var s = document.createElement('span');
      s.className = 'ab-color-count';
      s.textContent = n + ' Farben';
      ul.parentNode.insertBefore(s, ul);
    });
  }

  /* --- Optionswert -> Kurzname ------------------------------------------
     WICHTIG: Diese Zerlegung gilt NUR fuer die internen WC-Artikelnummern
     im Format 440-8200-... Auf andere Werte darf sie nicht angewendet
     werden, sonst wird aus "Waschplatz" ein "Modell Waschp / Weiss". */
  var SKU_RE = /^\d{3}-\d{3,4}/;

  function isSku(v) { return SKU_RE.test(v.trim()); }

  function shortModel(v) {
    var code = (v.match(/(\d{4})/) || [])[1] || v.slice(0, 6);
    var low = v.toLowerCase(), finish, dot;
    if (low.indexOf('schwarz') > -1 && low.indexOf('matt') > -1) { finish = 'Schwarz Matt'; dot = '#232323'; }
    else if (low.indexOf('schwarz') > -1) { finish = 'Schwarz'; dot = '#1A1A1A'; }
    else { finish = 'Weiß'; dot = '#F7F7F5'; }
    var seat = low.indexOf('almeira') > -1 ? 'Almeira-Slim Sitz'
             : low.indexOf('cera-slim') > -1 ? 'Cera-Slim Sitz'
             : low.indexOf('uni-slim') > -1 ? 'Uni-Slim Sitz'
             : low.indexOf('slim') > -1 ? 'Slim Sitz'
             : low.indexOf('uni') > -1 ? 'Uni Sitz' : 'WC-Sitz';
    return { head: 'Modell ' + code, finish: finish, dot: dot, seat: seat };
  }

  function money(cents) {
    return (cents / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/, '.') + ' €';
  }

  /* --- Produktdaten: eingebettet (Demo) oder per Endpoint (Live) --------- */
  function getProduct(cb) {
    if (window.__ALPEN_PRODUCT__) { cb(window.__ALPEN_PRODUCT__); return; }
    var m = location.pathname.match(/\/products\/[^/?#]+/);
    if (!m) { cb(null); return; }
    fetch(m[0] + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(cb)
      .catch(function () { cb(null); });
  }

  /* --- Kurzer Chip-Text aus dem Optionswert ------------------------------
     Lange interne Bezeichnungen passen nicht in einen Chip. Nur bekannte
     Muster werden gekuerzt, alles andere bleibt unveraendert stehen. */
  function chipText(raw, skuMode, wcStyle) {
    if (skuMode) {
      var s = shortModel(raw);
      return s.head.replace('Modell ', '') + ' · ' + s.finish;
    }
    if (wcStyle) {
      return raw.indexOf('Betätigungsplatte') > -1 ? '+ Drückerplatte' : 'Nur Spülkasten';
    }
    return raw.replace(/(\d)x(\d)/, '$1 × $2');
  }

  /* --- Ueberlauf: nur die ersten N Chips zeigen, Rest hinter "+N" -------- */
  function addOverflow(fs, labels) {
    if (labels.length <= CHIPS_VISIBLE + 1) return;

    var hidden = labels.slice(CHIPS_VISIBLE);

    /* Liegt die aktive Auswahl im verborgenen Bereich, wird nichts
       ausgeblendet - sonst sieht der Kunde seine Auswahl nicht. */
    var hiddenChecked = hidden.some(function (l) {
      var inp = document.getElementById(l.getAttribute('for'));
      return inp && inp.checked;
    });
    if (hiddenChecked) return;

    hidden.forEach(function (l) { l.classList.add('ab-chip-hidden'); });

    var more = document.createElement('button');
    more.type = 'button';
    more.className = 'ab-chip-more';
    more.textContent = '+' + hidden.length;
    more.setAttribute('aria-label', hidden.length + ' weitere Optionen anzeigen');
    more.addEventListener('click', function () {
      hidden.forEach(function (l) { l.classList.remove('ab-chip-hidden'); });
      more.remove();
    });
    fs.appendChild(more);
  }

  /* --- Varianten-Buttons umbauen ----------------------------------------
     Idempotent: bereits umgebaute Fieldsets tragen data-ab-done und werden
     uebersprungen. Nach einem Section-Rendering sind die Fieldsets neu und
     werden dadurch automatisch erneut bearbeitet. */
  function upgradePickers() {
    document.querySelectorAll('fieldset.product-form__input--button').forEach(function (fs) {
      if (fs.dataset.abDone) return;
      fs.dataset.abDone = '1';

      var labels = [].slice.call(fs.querySelectorAll('label'));
      if (!labels.length) return;

      var values = labels.map(function (l) {
        var inp = fs.querySelector('#' + CSS.escape(l.getAttribute('for')));
        return inp ? inp.value : l.textContent.trim();
      });

      // Nur wenn ALLE Werte Artikelnummern sind, darf zerlegt werden.
      var skuMode = values.every(isSku);
      // WC-Wortlaut nur, wenn die Werte auch davon handeln.
      var wcStyle = values.some(function (v) { return v.indexOf('Betätigungsplatte') > -1; });

      /* Einheitliche Darstellung fuer alle Optionen (Bernstein-Stil). */
      fs.classList.add('ab-chips');

      labels.forEach(function (l, i) {
        var raw = values[i];
        l.textContent = chipText(raw, skuMode, wcStyle);
        l.setAttribute('title', raw);
      });

      addOverflow(fs, labels);

      // Ausgewaehlten Wert in der Legende lesbar machen
      var sel = fs.querySelector('[data-selected-swatch-value]');
      if (sel) {
        var sync = function () {
          var ck = fs.querySelector('input:checked');
          if (!ck) return;
          if (skuMode) {
            var s = shortModel(ck.value);
            sel.textContent = s.head.replace('Modell ', '') + ' · ' + s.finish + ' · ' + s.seat;
          } else if (wcStyle) {
            sel.textContent = ck.value.indexOf('Betätigungsplatte') > -1
              ? '+ Drückerplatte' : 'Nur Spülkasten';
          } else {
            sel.textContent = ck.value;   // unveraendert: nichts zu kuerzen
          }
        };
        fs.addEventListener('change', sync);
        sync();
      }
    });
  }

  /* --- Galerie und Preis auf die gewaehlte Variante setzen --------------
     Das Theme rendert bereits fuer jede Variante ein eigenes
     .variant-gallery-set[data-variant-id]. Umgeschaltet wird ueber .is-active.
     Live erledigt das die Theme-Logik; diese Funktion ist idempotent und
     greift auch dann, wenn das Section-Rendering ausfaellt.
     Preis und Formularwert werden nur im eingebetteten Modus gesetzt,
     damit auf der Live-Seite die Theme-Logik allein zustaendig bleibt. */
  /* Die Seite rendert das Variantenformular mehrfach (Hauptbereich und
     Sticky-Leiste). Ohne Eingrenzung auf EINEN Container werden die
     Auswahlen aller Kopien vermischt und keine Variante gefunden. */
  function pickerRoot(el) {
    return (el && el.closest('variant-selects')) ||
           document.querySelector('variant-selects') || document;
  }

  function currentVariant(product, from) {
    if (!product) return null;
    var root = pickerRoot(from);
    var n = product.options.length;
    var picks = [];
    root.querySelectorAll('fieldset.product-form__input--button, ' +
      'fieldset.product-form__input--color, fieldset.product-form__input--swatch')
      .forEach(function (fs) {
        if (picks.length >= n) return;
        var ck = fs.querySelector('input[type="radio"]:checked');
        if (ck) picks.push(ck.value);
      });
    if (picks.length !== n) return null;
    for (var i = 0; i < product.variants.length; i++) {
      var v = product.variants[i], ok = true;
      for (var j = 0; j < picks.length; j++) {
        if (v.options[j] !== picks[j]) { ok = false; break; }
      }
      if (ok) return v;
    }
    return null;
  }

  function syncGallery(product, from) {
    var v = currentVariant(product, from);
    if (!v) return;
    /* Die Galerie stammt aus einem Custom-Code-Block des Shops. Sichtbar
       geschaltet wird dort ueber ein inline style="display:..." - die Klasse
       .is-active allein bewirkt optisch nichts. Deshalb beides setzen. */
    var sets = document.querySelectorAll('.variant-gallery-set[data-variant-id]');
    sets.forEach(function (s) {
      var on = s.getAttribute('data-variant-id') === String(v.id);
      s.classList.toggle('is-active', on);
      s.style.display = on ? 'block' : 'none';
    });
    if (!window.__ALPEN_PRODUCT__) return;   // live: Theme uebernimmt Preis/Formular

    document.querySelectorAll('input[name="id"]').forEach(function (i) { i.value = v.id; });

    /* Das Theme haelt zwei Preisbloecke bereit und blendet ueber die Klasse
       f-price--on-sale um. Nur den Sale-Block zu fuellen genuegt nicht -
       bei Artikeln ohne Streichpreis bleibt dann der alte Wert stehen.
       Ein Streichpreis gilt nur, wenn er ueber dem Verkaufspreis liegt;
       im Shop stehen teils 0,00 oder zu niedrige Werte. */
    var onSale = !!(v.compare_at_price && v.compare_at_price > v.price);
    document.querySelectorAll('[id^="price-"] .f-price').forEach(function (box) {
      var reg = box.querySelector('.f-price__regular .f-price-item--regular');
      var sale = box.querySelector('.f-price__sale .f-price-item--sale');
      var old = box.querySelector('.f-price__sale .f-price-item--regular s');
      if (reg) reg.textContent = money(v.price);
      if (sale) sale.textContent = money(v.price);
      if (old) old.textContent = onSale ? money(v.compare_at_price) : '';
      box.classList.toggle('f-price--on-sale', onSale);
    });
  }

  function optIndex(product, optName) {
    if (!product || !product.options) return 0;
    for (var i = 0; i < product.options.length; i++) {
      var n = typeof product.options[i] === 'string' ? product.options[i] : product.options[i].name;
      if (n === optName) return i;
    }
    return 0;
  }

  function findVariant(product, optName, value) {
    if (!product) return null;
    var ix = optIndex(product, optName);
    for (var i = 0; i < product.variants.length; i++) {
      if (product.variants[i].options[ix] === value) return product.variants[i];
    }
    return null;
  }

  function variantImage(product, optName, value) {
    var v = findVariant(product, optName, value);
    if (!v) return null;
    if (v.featured_image && v.featured_image.src) return v.featured_image.src;
    return v.featured_media && v.featured_media.preview_image
      ? v.featured_media.preview_image.src : null;
  }

  function variantPrice(product, optName, value) {
    // Preis der zweiten Option im Kontext der aktuell gewaehlten ersten
    if (!product) return null;
    var ix = optIndex(product, optName);
    var root = pickerRoot(null);
    var checked = [].slice.call(root.querySelectorAll(
      'fieldset.product-form__input--button input:checked'))
      .slice(0, product.options.length).map(function (i) { return i.value; });
    for (var i = 0; i < product.variants.length; i++) {
      var vr = product.variants[i];
      if (vr.options[ix] !== value) continue;
      var ok = true;
      for (var j = 0; j < vr.options.length; j++) {
        if (j !== ix && checked[j] && vr.options[j] !== checked[j]) { ok = false; break; }
      }
      if (ok) return vr.price;
    }
    return null;
  }

  /* --- Nach Nachladen erneut aufbauen -----------------------------------
     Kleiner Aufschub, damit ein Section-Rendering mit vielen Einzel-
     mutationen nur einen Durchlauf ausloest. 
  var reflowTimer = null;
  function scheduleReflow() {
    if (reflowTimer) return;
    reflowTimer = setTimeout(function () {
      reflowTimer = null;
      fixSwatches(document);
      colorCount(document);
      upgradePickers();
    }, 0);
  }
*/
  /* Direkt ausfuehren, nicht per setTimeout. Der MutationObserver laeuft
     noch VOR dem naechsten Paint - ein setTimeout dagegen erst danach,
     wodurch das rohe Markup fuer einen Frame sichtbar wurde. */
  function scheduleReflow() {
    fixSwatches(document);
    colorCount(document);
    upgradePickers();
  }

  /* --- Start ------------------------------------------------------------- */
  function init() {
    fixSwatches(document);
    colorCount(document);

    /* Die Chips brauchen keine Produktdaten - sofort aufbauen, sonst
       blitzen die langen Originalwerte bis zum Ende des fetch auf. */
    upgradePickers();

    if (document.querySelector('fieldset.product-form__input--button')) {
      getProduct(function (p) {
        PRODUCT = p;
        if (!p) return;
        // Preise der zweiten Option nach jedem Wechsel neu stellen
        var refresh = function (from) {
          document.querySelectorAll('[data-price-for]').forEach(function (el) {
            var fs = el.closest('fieldset');
            var legend = fs.querySelector('legend .font-body-bolder');
            var name = legend ? legend.textContent.replace(/:\s*$/, '').trim() : '';
            var pr = variantPrice(p, name, el.dataset.priceFor);
            if (pr) el.textContent = money(pr);
          });
          syncGallery(p, from);
        };
        document.addEventListener('change', function (e) {
          if (e.target && e.target.type === 'radio') {
            setTimeout(function () { refresh(e.target); }, 0);
          }
        });
        refresh(null);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Nachgeladene Inhalte (Variantenwechsel, Filter, Paginierung, Quick-View).
     Das Fieldset kann der hinzugefuegte Knoten SELBST sein - deshalb neben
     querySelector auch matches pruefen, sonst bleibt der Wechsel unerkannt. */
  new MutationObserver(function (muts) {
    var sel = '.swatch-color, .product-form__input--button';
    var hit = false;
    muts.forEach(function (m) {
      m.addedNodes.forEach(function (n) {
        /*if (hit || n.nodeType !== 1) return;*/
        if (n.nodeType !== 1) return;
        if ((n.matches && n.matches(sel)) ||
            (n.querySelector && n.querySelector(sel))) hit = true;
      });
    });
    if (hit) scheduleReflow();
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
